import React from 'react'
import ReactDOM from 'react-dom/client'
import router from '@/routes'
import { RouterProvider } from 'react-router-dom'
import 'normalize.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
)
